/**
 * Created by 不动的推动者 on 2018/5/2.
 */
//
import Vue from 'vue'
import Router from 'vue-router'

const Login = resolve => require(['../page/login/login'], resolve);
const Home = resolve => require(['../page/home/home'], resolve);
const Dashboard = resolve => require(['../page/Dashboard'], resolve);
const MyExpenseAccount =  resolve => require(['../page/expenseAccount/ExpenseAccountView'], resolve);
const AddExpenseAccount =  resolve => require(['../page/expenseAccount/AddExpenseAccountView'], resolve);
const ExpenseApprove =  resolve => require(['../page/expenseAccount/ExpenseApprove'], resolve);
const AddExpenseNoApproveView =  resolve => require(['../page/expenseAccount/AddExpenseNoApproveView'], resolve);
const ExpenseHome =  resolve => require(['../page/expenseAccount/ExpenseHome'], resolve);
const AddIncomeAccount =  resolve => require(['../page/incomeAccount/AddIncomeAccountView'], resolve);
const PurchaseOrderMaterial =  resolve => require(['../page/Purchase/PurchaseMaterialView'], resolve);
const PurchaseOrderEdge =  resolve => require(['../page/Purchase/PurchaseEdgeView'], resolve);
const AddPurchaseMaterialView =  resolve => require(['../page/Purchase/AddPurchaseMaterialView'], resolve);
const AddPurchaseEdgeView =  resolve => require(['../page/Purchase/AddPurchaseEdgeView'], resolve);
const MyIncomeAccount =  resolve => require(['../page/incomeAccount/IncomeAccountView'], resolve);

const Structure = resolve => require(['../page/set/structure'], resolve);
const UpdatePWD = resolve => require(['../page/set/updatePWD'], resolve);

// 爸爸
const Baba = resolve => require(['../page/login/baba'], resolve);

Vue.use(Router);


export default new Router({
  routes: [
    {
      path: '/login',
      component: Login,
    },
    {
      path: '/baba',
      component: Baba,
    },
    {
      path:'/',
      component: Home,
      meta: { requiresAuth: true },
      children: [
        {
          path: '',
          component: ExpenseHome,
          meta: { title: '我要报销',  requiresAuth: true}
        },
        { //我的报销
          path: '/dashboard',
          component: Dashboard,
          meta: { title: '总览',  requiresAuth: true }
        },
        { //我的报销
          path: '/expense_account',
          component: MyExpenseAccount,
          meta: { title: '我的报销',  requiresAuth: true }
        },
        { //新增报销
          path: '/expense_account_add',
          component: AddExpenseAccount,
          meta: { title: '新增报销',  requiresAuth: true }
        },
        { //我的支出
          path: '/expense_no_approve_add',
          component: AddExpenseNoApproveView,
          meta: { title: '上报支出',  requiresAuth: true }
        },
        { //审核报销单
          path: '/expense_approve',
          component: ExpenseApprove,
          meta: { title: '审核报销单',  requiresAuth: true }
        },
        { //我的支出
          path: '/income_account_add',
          component: AddIncomeAccount,
          meta: { title: '上报收入',  requiresAuth: true }
        },
        { // 面料采购管理
          path: '/purchase_order_material',
          component: PurchaseOrderMaterial,
          meta: { title: '面料采购管理',  requiresAuth: true }
        },
        { // 辅料采购管理
          path: '/purchase_order_edge',
          component: PurchaseOrderEdge,
          meta: { title: '辅料采购管理',  requiresAuth: true }
        },
        { //新增面料采购订单
          path: '/purchase_order_material_add',
          component: AddPurchaseMaterialView,
          meta: { title: '新增采购订单',  requiresAuth: true }
        },
        { //新增辅料采购订单
          path: '/purchase_order_edge_add',
          component: AddPurchaseEdgeView,
          meta: { title: '新增采购订单',  requiresAuth: true }
        },
        { //我的收入
          path: '/income_account',
          component: MyIncomeAccount,
          meta: { title: '我的收入',  requiresAuth: true }
        },
        /**
        * 设置
        * */
        //修改密码
        {
          path: '/UpdatePWD',
          component: UpdatePWD,
          meta: { title: '修改密码'}
        }
      ]
    },
    {
      path: '/login',
      component: Login,
      meta: { title: '登陆' }
    }
  ]


})



// WEBPACK FOOTER //
// ./src/router/index.js